<!--
https://github.com/vuetifyjs/vuetify/blob/master/packages/docs/src/layouts/default/settings/Group.vue
-->
<template>
<div class="px-4">
  <h4
      v-if="title"
      class="mb-0 mt-4"
    >{{ title }}</h4>
  <v-item-group
      class="mx-auto row row--dense"
      mandatory
    >
      <v-col
        v-for="({ icon, value, text, cb }) in items"
        :key="text"
        cols="6"
      >
        <v-item :value="value">
           <v-card
              :color="value === defaultValue ? 'primary' : `grey ${theme === 'dark' ? 'darken' : 'lighten'}-3`"
              class="v-card--group py-3 px-4 text-center position-relative cursor-pointer d-flex align-center justify-space-between"
              rounded
              flat
              @click="cb({value})"
            >
              {{ $t(text) }}
              <v-icon v-if="icon" v-text="icon" />
            </v-card>
        </v-item>
      </v-col>
    </v-item-group>
</div>
</template>

<script>

import { get } from 'vuex-pathify'

export default {
  name: 'DefaultSettingItems',
  props: ['items', 'defaultValue', 'title'],
  computed: {
    theme: get('app/theme')
  }
}
</script>
